import React from 'react';
import '../../../../src/loaderOverlay.scss'; // Import CSS for styling the loader

const LoaderOverlay = () => (
  <div className="loader-overlay">
    <div className="loader"></div>
  </div>
);

export default LoaderOverlay;
